import { Form } from 'factorial-form'
import {
  ContractsCustomFieldsPoliciesFragment,
  TaskDetailCustomFieldsContextlessPoliciesFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { translations as legalAndExtrasTranslations } from 'modules/contracts/components/FixFlow/lib/legalAndExtrasTranslations'
import { ContractFlowType } from 'modules/contracts/components/FlowPage'

import CustomFieldsSection from 'modules/contracts/components/FlowPage/Steps/LegalAndExtras/_CustomFields'

interface Props {
  form: Form
  translations?: { [key: string]: string }
  step?: number
  type?: ContractFlowType
  withFormWrapper?: boolean
  customFieldsContextlessPolicies:
    | ContractsCustomFieldsPoliciesFragment
    | TaskDetailCustomFieldsContextlessPoliciesFragment
    | undefined
  legalEntityId: string
}

const CustomFields = ({
  form,
  step,
  type = 'fix',
  withFormWrapper,
  translations = legalAndExtrasTranslations(),
  customFieldsContextlessPolicies,
  legalEntityId,
}: Props) => {
  return (
    <CustomFieldsSection
      withFormWrapper={withFormWrapper}
      form={form}
      translations={translations}
      step={step}
      type={type}
      customFieldsContextlessPolicies={customFieldsContextlessPolicies}
      legalEntityId={legalEntityId}
    />
  )
}

export default observer(CustomFields)
